"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getControlHoverStatePlugin = void 0;
const getControlHoverStatePlugin = isDesktop => ({
  id: 'controlHoverStatePlugin',
  beforeEvent(chart, args) {
    const event = args.event;
    const hoverOnEvent = isDesktop ? 'mousemove' : 'click';
    const hoverOffEvent = isDesktop ? 'mouseout' : 'mouseout';
    if (event.type === hoverOffEvent && chart.isHover) {
      chart.isHover = false;
      chart.update();
    } else if (event.type === hoverOnEvent && !chart.isHover) {
      chart.isHover = true;
      chart.update();
    }
  }
});
exports.getControlHoverStatePlugin = getControlHoverStatePlugin;